import React, { useState, useEffect } from 'react';
import Card from '../../../components/card.component';
import {
  Col,
  Row,
} from 'react-bootstrap';
import table from '../reportes.table';
import DataTable from 'react-data-table-component';
import sucursalFunction from '../../sucursales/sucursal.functions';
import moment from 'moment';
import notification from '../../../components/notification.component';
import PrinterCaja from '../imprimir/caja.printer';
import reportesFunctions from '../reportes.functions';

const SucursalReportes = () => {

  const rpValuesOne = {
    init: moment().format('YYYY-MM-DD'),
    end: moment().format('YYYY-MM-DD'),
    sucursales: [],
  }
  const [sucursales, setSucursales] = useState([]);
  const [reporteOne, setRerporteOne] = useState(rpValuesOne);
  const [dataRpOne, setDataRpOne] = useState(null);
  const [toggleOne, setToggleOne] = useState(false);

  useEffect(() => {
    listarSucursales();
  },[])


  const resetReportOne = () => {
    setRerporteOne(rpValuesOne);
    setToggleOne(!toggleOne);
    setDataRpOne(null);
  }

  const listarSucursales = () => {
    sucursalFunction.listado().then((response) => {
      setSucursales(response.data);
    })
  }

  const sucursalSelected = (rows) => {
    setRerporteOne({
      ...reporteOne,
      sucursales: rows.selectedRows,
    });
    setDataRpOne(null);
  }

  const setValueRpOne = (e) => {
    setRerporteOne({
      ...reporteOne,
      [e.target.name]: e.target.value,
    });
  }

  const generarReporteOne = () => {
    if (reporteOne.sucursales.length) {
      const ids = reporteOne.sucursales.map((e) => e.id);
      reportesFunctions.sucursales({ sucursales: ids, init: reporteOne.init }).then((response) => {
        setDataRpOne(response.results);
      })
    } else {
      notification.warning('Debe seleccionar al menos una sucursal')
    }
  }

  return (
    <>
    <Row className="mt-3">
      <Col>
        <Card>
          <div>Total por sucursal</div>
          <DataTable
            title="Sucursales"
            customStyles={table.customStyles}
            columns={table.columnSucursales}
            data={sucursales}
            dense={true}
            pagination={true}
            paginationPerPage={100}
            selectableRows={true}
            onSelectedRowsChange={sucursalSelected}
            clearSelectedRows={toggleOne}
            contextMessage={{
              singular: 'Sucursal',
              plural: 'Sucursales',
              message: 'seleccionados',
            }}
          />
        
          <div className="d-flex">
           <div className="grupo-input mr-2">
            <small>Desde</small>
            <input onChange={setValueRpOne} name="init" type="date" className="form-control" defaultValue={reporteOne.init}/>
           </div>
          </div>
          <div className="mt-2 d-flex">
           <button onClick={generarReporteOne} type="button" className="btnx btnx-warn">Generar</button> {' '}
           <button onClick={resetReportOne} type="button" className="btnx btnx-warn">Limpiar</button> {' '}
           {dataRpOne !== null ? <PrinterCaja data={dataRpOne} suc={reporteOne.sucursales.length}/> : null}
          </div>
        </Card>
      </Col>
    </Row>
    </>
  )
}

export default SucursalReportes;